module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Myths&Monsters.fa4f64c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Myths&Monsters.jpg
// module id = 0NZW
// module chunks = 0